import { useMemo } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useIntl } from "react-intl"

/**
 * Fetch localized versions of all Cosmic story objects that attended a given school
 * @param {string} schoolSlug 
 * @returns {Object[]} array of Cosmic story objects
 */
export const useAlumniStories = (schoolSlug) => {
  const { locale } = useIntl()
  const { allStories } = useStaticQuery(graphql`
    query {
      allStories: allCosmicjsStories {
        nodes {
          locale
          slug
          title
          metadata {
            story_job_title
            story_location
            story_quote
            story_company
            story_video_url
            story_company
            story_personal_photo {
              imgix_url
            }
            story_school_reference {
              slug
            }
          }
        }
      }
    }
  `)

  const alumniStories = useMemo(() => (
    allStories.nodes.filter(node =>
      node.locale === locale
      && node.metadata.story_school_reference?.some(schoolRef => schoolRef.slug === schoolSlug)
    )
  ), [locale, schoolSlug, allStories.nodes])

  return alumniStories
}
